import { useQuery } from "@tanstack/react-query";
import { useT } from "../i18n/locale";
import { useOptionalAccess, useOptionalTab } from "../session/access";
import type { TabContext } from "../session/tab-context";
import { whatsAppUnreadQuery } from "./whatsapp-queries";

// Il numero dei WhatsApp da leggere accanto a «Conversazioni» nel menu (piano M6, R3, passo 12b; D24; ruling R3 «Il menu»): con la
// rail aperta e fissa, con la rail a icone (sull'icona) e nel pannello del telefono. Il numero si vede soltanto; le parole («3 WhatsApp
// da leggere») stanno in un elemento nascosto che la voce usa come descrizione, mai nel suo nome. Senza niente da leggere non c'è.
// Si legge come il banner dei richiami (`whatsAppUnreadQuery`: ogni 60 secondi, al ritorno sulla finestra, dopo ogni lettura); nel
// contesto di piattaforma no, come il banner: ogni lettura resterebbe nel registro dell'azienda (D13). Lì il numero lo dice il
// pulsante della scheda «WhatsApp», a pagina aperta.

export function WhatsAppRailCount({ id }: { id: string }) {
  const access = useOptionalAccess();
  const tab = useOptionalTab();
  if (!access || !tab || access.isPlatform) return null;
  return <RailCount tab={tab} id={id} />;
}

/** Il numero sull'icona resta stretto: oltre 99 si legge «99+», e le parole dicono il numero intero. */
const MAX_SHOWN = 99;

function RailCount({ tab, id }: { tab: TabContext; id: string }) {
  const t = useT();
  const count = useQuery(whatsAppUnreadQuery(tab)).data?.count ?? 0;
  if (count === 0) return null;
  const shown = count > MAX_SHOWN ? `${MAX_SHOWN}+` : String(count);
  return (
    <>
      <span className="g-nav__count" aria-hidden="true">
        {shown}
      </span>
      <span id={id} hidden>
        {count === 1 ? t("conversations.whatsapp.unreadOne") : t("conversations.whatsapp.unreadMany", { count })}
      </span>
    </>
  );
}
